import React from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, Grid, Container, } from "@material-ui/core";
import CreateIcon from '@material-ui/icons/Create';
import { ToastContext } from "../Common/ToastProvider";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import {
    updatePricing,
    getPricing,
    updateConnection,
    findConnectionByAgent,
    getAllAgents,
    fetchSalesHistory,
    sendSmsToAgent,
} from "../api/connection";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from '@material-ui/core/InputLabel';
import Select from "@material-ui/core/Select";
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import MaterialTable from 'material-table';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import CardMedia from '@material-ui/core/CardMedia';
import { getRole, getUserName } from "../Common/utils/auth";
import { usePDF } from 'react-to-pdf';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
    head: {
        backgroundColor: 'blue',
        color: 'white',
    },
    table: {
        minWidth: 500,
    },
    formControl: {
        minWidth: "50%",
    },
    selectEmpty: {
        marginTop: '',
    },
    root: {
        flexGrow: 1,
    },
    paper: {
        textAlign: 'center',
    },
    cardMedia: {
        paddingTop: '46.25%', // 16:9
    },
    tableContainer: {
        margin: "5px"
    },
    heading: {
        color: '#e91e63', // Change heading color as needed
        fontSize: '20px',
        textAlign: 'center',
    },
    value: {
        color: 'blue',
        fontSize: '20px',
    },
    actionButton: {
        display: 'flex',
        justifyContent: 'center',
    }
});



const ConnectionDashboard = () => {
    const classes = useStyles();
    const { showToast } = React.useContext(ToastContext);
    const [show, setShow] = React.useState(false)
    const [agentList, setAgetList] = React.useState([]);
    const [sms, setSms] = React.useState({
        "agent": "",
        "load": 0,
        "regulator": 0,
        "pipe": 0,
        "light": 0,
        "bplOven": 0,
        "nonHpOven": 0,
        "hpOven": 0,
        "installationPending": 0,
        "paidAmount": 0,
        "dueAmount": 0
    })
    const [customer, setCustomer] = React.useState({
        agent: "",
    });
    const [open, setOpen] = React.useState(false);
    const [agent, setAgent] = React.useState({
        "agent_photo": "",
        "agent": "",
        "totalConnection": 0,
        "load": 0,
        "regulator": 0,
        "pipe": 0,
        "totalLight": 0,
        "paidLight": 0,
        "bplOven": 0,
        "nonHpOven": 0,
        "hpOven": 0,
        "paidAmount": 0,
        "remarks": " ",
        "installationComplete": 0
    })

    const [connection, setConnection] = React.useState({
        "agent": "",
        "totalConnection": 0,
        "load": 0,
        "regulator": 0,
        "pipe": 0,
        "totalLight": 0,
        "paidLight": 0,
        "bplOven": 0,
        "nonHpOven": 0,
        "hpOven": 0,
        "paidAmount": 0,
        "remarks": " ",
    })


    const [pricing, setPricing] = React.useState({})
    const [openPrice, setOpenPrice] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false)
    const [loadingTable, setLoadingTable] = React.useState(false)


    const getTargetElement = () => document.getElementById('pdfId');

    const handleClickOpen = () => {
        setOpenPrice(true);
    };

    const handleClose = () => {
        setOpenPrice(false);
    };


    const handleChangePricing = (event: any) => {
        setPricing({ ...pricing, [event.target.name]: event.target.value });
    }

    const handleUpdatePricing = async () => {
        try {
            const result = await updatePricing(pricing);
            if (result.data) {
                showToast(result.message, "success");
                setOpenPrice(false);
            }
        } catch (error: any) {
            if (error.response) {
                showToast(error.response.data.message, "error");
            }
        }
    };


    const handleChange = (event: any) => {
        setConnection({ ...connection, [event.target.name]: event.target.value });
    }

    const handleChangeSMS = (event: any) => {
        setSms({ ...sms, [event.target.name]: event.target.value });
    }


    const handleUpdateConnection = async () => {
        setOpen(false);
        try {
            const connectionData = {
                "agent": customer.agent,
                "totalConnection": connection.totalConnection,
                "load": connection.load,
                "regulator": connection.regulator,
                "pipe": connection.pipe,
                "totalLight": connection.totalLight,
                "paidLight": connection.paidLight,
                "bplOven": connection.bplOven,
                "nonHpOven": connection.nonHpOven,
                "hpOven": connection.hpOven,
                "paidAmount": connection.paidAmount,
                "remarks": connection.remarks,
                "updatedBy": getUserName()
            };
            const result = await updateConnection(connectionData);
            if (result.data) {
                showToast(result.message, "success");
                setOpen(false);
                setConnection({
                    "agent": "",
                    "totalConnection": 0,
                    "load": 0,
                    "regulator": 0,
                    "pipe": 0,
                    "totalLight": 0,
                    "paidLight": 0,
                    "bplOven": 0,
                    "nonHpOven": 0,
                    "hpOven": 0,
                    "paidAmount": 0,
                    "remarks": " ",
                });
            }
        } catch (error: any) {
            if (error.response) {
                showToast(error.response.data.message, "error");
            }
        }
    };


    React.useEffect(() => {
        fetchAllAgents();
        fetchPricing();
    }, []);



    const fetchPricing = async () => {
        try {
            const result = await getPricing();
            if (result) {
                setPricing(result);
            }
        } catch (error: any) {
            if (error.response) {
                showToast(error.response.data.message, "error");
            }
        }
    };



    const findOwnConnectionData = async () => {
        try {
            const result = await findConnectionByAgent(getUserName());
            if (result) {
                setAgent(result);
                setShow(true);
            }
        } catch (error: any) {
            if (error.response) {
                showToast(error.response.data.message, "error");
            }
        }
    };



    const handleFindConnection = async () => {
        try {
            if (getRole() === "user") {
                findOwnConnectionData();
            } else {
                const result = await findConnectionByAgent(customer.agent);
                if (result) {
                    setAgent(result);
                    setShow(true);
                }
            }
        } catch (error: any) {
            if (error.response) {
                showToast(error.response.data.message, "error");
            }
        }
    };


    const handleChangeAgent = (event: any) => {
        setCustomer({ ...customer, [event.target.name]: event.target.value });
        setConnection({ ...connection, [event.target.name]: event.target.value })
        setSms({ ...sms, [event.target.name]: event.target.value })
    }


    const fetchAllAgents = async () => {
        try {
            const result = await getAllAgents();
            setAgetList(result.map(({ name }: any) => ({ label: name, value: name })));
        } catch (error: any) {
            if (error.response) {
                showToast(error.response.data.message, "error");
            }
        }
    };


    const handleFetchSalesData = async () => {
        try {
            setLoadingTable(true);
            setLoading(true);
            let result;
            if (getRole() === "user") {
                result = await fetchSalesHistory(getUserName());
            } else {
                result = await fetchSalesHistory(customer.agent);
            }
            if (result) {
                setData(result);
                setLoading(false);
                setLoadingTable(false); // Set to false after data is loaded
            }
        } catch (error: any) {
            if (error.response) {
                showToast(error.response.data.message, "error");
            }
        }
    };


    // This function is now consolidated into handleFetchSalesData

    const handleSendSms = async () => {
        try {
            const result = await sendSmsToAgent(sms);
            if (result) {
                showToast(result.message, "success");
            }
        } catch (error: any) {
            if (error.response) {
                showToast(error.response.data.message, "error");
            }
        }
    };



    const columns = [
        { title: 'AGENT', field: 'agent' },
        { title: "TOTAL CONNECTION ", field: "totalConnection", type: 'numeric' },
        { title: "LOAD PAID", field: "load", type: 'numeric' },
        { title: "REGULATOR PAID", field: "regulator" },
        { title: "PIPE PAID", field: "pipe" },
        { title: "LIGHT PAID", field: "paidLight" },
        { title: "BPL OVEN", field: "bplOven" },
        { title: "NON HP OVEN", field: "nonHpOven" },
        { title: "HP OVEN", field: "hpOven" },
        { title: "OVEN DUE", field: "bplOven" },
        { title: "PAID AMOUNT ", field: "paidAmount" },
        { title: "REMARKS ", field: "remarks" },
        {
            title: "DATE ", field: "updatedAt", type: "date",
            dateSetting: { locale: "ko-KR" }
        }
    ]

    const options = {
        // default is `save`
        method: 'save',
        // default is Resolution.MEDIUM = 3, which should be enough, higher values
        // increases the image quality but also the size of the PDF, so be careful
        // using values higher than 10 when having multiple pages generated, it
        // might cause the page to crash or hang.
        resolution: Resolution.MEDIUM,
        page: {
            margin: Margin.SMALL,
            // default is 'A4'
            format: 'A3',
            // default is 'portrait'
            orientation: 'portrait',
        },
        canvas: {
            // default is 'image/jpeg' for better size performance
            mimeType: 'image/png',
            qualityRatio: 1
        },
        overrides: {
            pdf: {
                compress: true
            },
            canvas: {
                useCORS: true
            }
        },
    };



    return (
        <React.Fragment>
            <Container style={{ justifyContent: "center", alignContent: "center", textAlign: "center", marginTop: "4rem" }}>
                <Grid item xs={12} sm={12} md={12}  >
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="demo-simple-select-required-label">Agent Name *</InputLabel>
                        {getRole() != "user" ?
                            <Select
                                displayEmpty
                                className={classes.selectEmpty}
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                inputProps={{ 'aria-label': 'Without label' }}
                                name="agent"
                                onChange={handleChangeAgent}
                            >
                                {agentList.map(item => (
                                    <MenuItem
                                        //@ts-ignore
                                        key={item.label} value={item.value} >{item.label}</MenuItem>
                                ))}
                            </Select> :
                            <Typography variant="button" display="block" gutterBottom> <span style={{ color: "blue", fontSize: "20px" }}>{getUserName()}</span></Typography>}
                    </FormControl>
                </Grid>

                <Grid item style={{ marginTop: "1rem" }}>
                    <Button
                        variant="contained"
                        component="label"
                        color="primary"
                        onClick={handleFindConnection}
                    >
                        FETCH & UPDATE
                    </Button>
                    <Button
                        variant="contained"
                        component="label"
                        color="secondary"
                        onClick={handleFetchSalesData}
                    >
                        VIEW HISTORY
                    </Button>

                </Grid>
                {show ?
                    <Grid container spacing={3} style={{ marginTop: "2rem" }}>




                        <Grid item xs={12} md={4}>
                            <Card >
                                <CardMedia
                                    style={{ height: 0, paddingTop: '56.25%' }}
                                    image={agent.agent_photo || "https://picsum.photos/200/300?random=2"}
                                    title="Image title"
                                />
                                {/* @ts-ignore */}
                                <Button variant='contained' onClick={() => generatePDF(getTargetElement, options)} color='primary' size='small'>Download PDF</Button>
                                <CardContent id="pdfId">
                                    <Typography variant="button" display="block" gutterBottom>
                                        <span style={{ color: "#e91e63", fontSize: "20px", textAlign: "center" }}>
                                            {agent.agent}
                                        </span>
                                    </Typography>

                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>TOTAL CONNECTION:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.totalConnection}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>LOAD PAID:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.load}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>INSTALLATION COMPLETE:</TableCell>
                                                <TableCell style={{ color: "#e91e63" }}>{agent.installationComplete}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>PENDING INSTALLATION:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.load - agent.installationComplete}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>CONNECTION DUE:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.totalConnection - agent.load}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>REGULATOR PAID:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.regulator}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>REGULATOR DUE:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.load - agent.regulator}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>PIPE PAID:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.pipe}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>PIPE DUE:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.load - agent.pipe}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>LIGHT PAID:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.paidLight}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>LIGHT DUE:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.hpOven + agent.nonHpOven - agent.paidLight}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>BPL OVEN:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.bplOven}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>NON HP OVEN:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.nonHpOven}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>HP OVEN:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.hpOven}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>OVEN DUE:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.load - agent.hpOven - agent.nonHpOven - agent.bplOven}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>TOTAL AMOUNT:</TableCell>
                                                <TableCell style={{ color: "blue" }}>
                                                    {/* @ts-ignore */}
                                                    {agent.nonHpOven * pricing.nonHpOvenPricing + agent.hpOven * pricing.hpOvenPricing}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>AMOUNT PAID:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.paidAmount}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>AMOUNT DUE:</TableCell>
                                                <TableCell style={{ color: "blue" }}>
                                                    {/* @ts-ignore */}

                                                    {agent.nonHpOven * pricing.nonHpOvenPricing + agent.hpOven * pricing.hpOvenPricing - agent.paidAmount}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>REMARKS:</TableCell>
                                                <TableCell style={{ color: "blue" }}>{agent.remarks}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>ACTION:</TableCell>
                                                <TableCell>
                                                    {getRole() === "admin" || getRole() === "superadmin" ? (
                                                        <IconButton aria-label="delete" size="medium" onClick={() => setOpen(true)}>
                                                            <CreateIcon />
                                                        </IconButton>
                                                    ) : (
                                                        "No option"
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </CardContent>
                            </Card>
                        </Grid>
                        {getRole() === "admin" || getRole() === "superadmin" ?
                            <Grid item xs={12} md={4}>

                                <Card >

                                    <CardContent>
                                        <Typography gutterBottom>
                                            Send SMS Update to <span style={{ color: "#e91e63", paddingTop: "3rem" }}>{agent.agent}</span>
                                        </Typography>
                                        <Grid container spacing={1} style={{ marginTop: "2rem" }}>
                                            <Grid item xs={6}   >
                                                <div style={{ margin: "2px" }}>

                                                    <TextField label="Load"
                                                        id="standard-size-small"
                                                        size="small"
                                                        value={sms.load}
                                                        onChange={handleChangeSMS}
                                                        name="load"
                                                        type="Number"

                                                    />
                                                    <TextField label="Regulator"
                                                        id="standard-size-normal"
                                                        size="small"
                                                        value={sms.regulator}
                                                        onChange={handleChangeSMS}
                                                        name="regulator"
                                                        type="Number"

                                                    />
                                                    <TextField
                                                        label="HP Oven"
                                                        id="standard-size-small"
                                                        size="small"
                                                        value={sms.hpOven}
                                                        onChange={handleChangeSMS}
                                                        name="hpOven"
                                                        type="Number"

                                                    />
                                                    <TextField label="BPL Oven"
                                                        id="standard-size-normal"
                                                        size="small"
                                                        value={sms.bplOven}
                                                        onChange={handleChangeSMS}
                                                        name="bplOven"
                                                        type="Number"

                                                    />

                                                    <TextField label="Amount Paid"
                                                        id="standard-size-normal"
                                                        size="small"
                                                        value={sms.paidAmount}
                                                        onChange={handleChangeSMS}
                                                        name="paidAmount"
                                                        type="Number"

                                                    />

                                                </div>
                                            </Grid>
                                            <Grid item xs={6} >
                                                <TextField label="Pipe"
                                                    id="standard-size-normal"
                                                    size="small"
                                                    value={sms.pipe}
                                                    onChange={handleChangeSMS}
                                                    name="pipe"
                                                    type="Number"

                                                />
                                                <TextField label="Non HP Oven"
                                                    id="standard-size-small"
                                                    size="small"
                                                    value={sms.nonHpOven}
                                                    onChange={handleChangeSMS}
                                                    name="nonHpOven"
                                                    type="Number"

                                                />
                                                <TextField label="Light"
                                                    id="standard-size-normal"
                                                    size="small"
                                                    value={sms.light}
                                                    onChange={handleChangeSMS}
                                                    name="light"
                                                    type="Number"

                                                />
                                                <TextField label="Installation Pending"
                                                    id="standard-size-normal"
                                                    size="small"
                                                    value={sms.installationPending}
                                                    onChange={handleChangeSMS}
                                                    name="installationPending"
                                                    type="Number"

                                                />
                                                <TextField label="Total Amount Due"
                                                    id="standard-size-normal"
                                                    size="small"
                                                    value={sms.dueAmount}
                                                    onChange={handleChangeSMS}
                                                    name="dueAmount"
                                                    type="Number"

                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <Button
                                        variant="contained"
                                        component="label"
                                        color="primary"
                                        size="large"
                                        onClick={handleSendSms}
                                    >
                                        SEND SMS
                                    </Button>
                                </Card>
                            </Grid> : null
                        }
                        {getRole() === "superadmin" && (

                            <Grid item xs={12} md={4}>
                                <Card style={{ backgroundColor: "#009688", color: "white", height: "11rem" }}>
                                    <CardContent>
                                        <Typography gutterBottom>
                                            Today's Pricing Table
                                        </Typography>
                                        <Typography variant="h6" component="h2">
                                            {/* @ts-ignore */}
                                            HP Oven Price : <b>{pricing.hpOvenPricing} &#x20B9;</b>
                                        </Typography>
                                        <Typography variant="h6" component="h2">
                                            {/* @ts-ignore */}
                                            Non HP Oven Price : <b>{pricing.nonHpOvenPricing} &#x20B9;</b>
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <Button size="small" onClick={() => setOpenPrice(true)}><CreateIcon fontSize="small" style={{ color: "white" }} /></Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                        )}
                    </Grid>
                    : null}
                <div>
                    <Dialog
                        open={openPrice}
                        keepMounted
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogTitle id="alert-dialog-slide-title">Update Oven Pricing :</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                            </DialogContentText>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="hpOvenPricing"
                                label="HP Oven"
                                type="number"
                                //@ts-ignore
                                value={pricing.hpOvenPricing}
                                name="hpOvenPricing"
                                variant="outlined"
                                onChange={handleChangePricing}

                            />
                            <TextField
                                autoFocus
                                margin="dense"
                                id="nonHpOvenPricing"
                                label="Non HP Oven"
                                type="number"
                                //@ts-ignore
                                value={pricing.nonHpOvenPricing}
                                name="nonHpOvenPricing"
                                variant="outlined"
                                onChange={handleChangePricing}

                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={handleUpdatePricing} color="primary">
                                update
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </Container>

            <div>
                <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title" style={{ backgroundColor: "#009688", color: '#FFF' }}> Update Connection : <span style={{ color: 'yellow' }}> {agent.agent}</span> </DialogTitle>

                    <DialogContent >

                        <DialogContentText style={{ backgroundColor: "#009688", color: "white" }}>
                            <div >
                                <Grid container spacing={3}>
                                    <Grid item xs={6} style={{ backgroundColor: "#009688", color: "white" }}>
                                        <List >
                                            <ListItem>
                                                Total Connection: {agent.totalConnection}
                                            </ListItem>
                                            <Divider />
                                            <ListItem>
                                                Load :{agent.load}
                                            </ListItem>
                                            <Divider />
                                            <ListItem>
                                                Regulator :{agent.regulator}
                                            </ListItem>
                                            <Divider />
                                            <ListItem>
                                                Pipe :{agent.pipe}
                                            </ListItem>
                                            <Divider />
                                            <ListItem>
                                                Light Paid :{agent.paidLight}
                                            </ListItem>
                                            <Divider />
                                        </List>
                                    </Grid>
                                    <Grid item xs={6} style={{ backgroundColor: "#009688", color: "white" }}>
                                        <List >
                                            <Divider />
                                            <ListItem>
                                                Light Paid :{agent.paidLight}
                                            </ListItem>
                                            <Divider />
                                            <ListItem>
                                                Non HP Oven  :{agent.nonHpOven}
                                            </ListItem>
                                            <Divider />
                                            <ListItem>
                                                HP Oven  :{agent.hpOven}
                                            </ListItem>
                                            <Divider />
                                            <ListItem>
                                                Total Amount Paid :{agent.paidAmount}
                                            </ListItem>
                                            <Divider />
                                            <ListItem>
                                                Remarks :{agent.remarks}
                                            </ListItem>
                                            <Divider />
                                        </List>
                                    </Grid>
                                </Grid>

                            </div>
                        </DialogContentText>
                        <Typography style={{ textAlign: "left", margin: "5px" }}>
                            Todays Delivery Update:
                        </Typography>

                        <div style={{ marginLeft: "3rem" }} >
                            {/* <TextField
                                autoFocus
                                margin="dense"
                                label="Total Connection"
                                type="Number"
                                value={connection.totalConnection}
                                name="totalConnection"
                                variant="outlined"
                                onChange={handleChange}
                                style={{ color: "white" }}
                            
                            /> */}
                            <TextField
                                autoFocus
                                margin="dense"
                                id="Load"
                                label="Load "
                                type="Number"
                                value={connection.load}
                                name="load"
                                variant="outlined"
                                onChange={handleChange}
                                size="medium"
                            />
                            <TextField
                                autoFocus
                                margin="dense"
                                id="regulator"
                                value={connection.regulator}
                                label="Regulator"
                                type="Number"
                                variant="outlined"
                                onChange={handleChange}
                                name="regulator"

                            />
                            <TextField
                                autoFocus
                                margin="dense"
                                id="pipe"
                                label="Pipe "
                                type="Number"
                                variant="outlined"
                                value={connection.pipe}
                                onChange={handleChange}
                                name="pipe"

                            />
                            <TextField
                                autoFocus
                                margin="dense"
                                id="paidLight"
                                label="Light Paid"
                                type="Number"
                                value={connection.paidLight}
                                variant="outlined"
                                onChange={handleChange}
                                name="paidLight"

                            />
                            <TextField
                                autoFocus
                                margin="dense"
                                id="bplOven"
                                label="BPL Oven"
                                type="Number"
                                variant="outlined"
                                value={connection.bplOven}
                                onChange={handleChange}
                                name="bplOven"


                            />
                            <TextField
                                autoFocus
                                margin="dense"
                                id="nonHpOven"
                                label="Non HP Oven"
                                type="Number"
                                variant="outlined"
                                value={connection.nonHpOven}
                                onChange={handleChange}
                                name="nonHpOven"

                            />
                            <TextField
                                autoFocus
                                margin="dense"
                                id="hpOven"
                                label="HP Oven"
                                type="Number"
                                variant="outlined"
                                value={connection.hpOven}
                                onChange={handleChange}
                                name="hpOven"

                            />
                            <TextField
                                autoFocus
                                margin="dense"
                                id="paidAmount"
                                label="Total Amount Paid"
                                type="Number"
                                variant="outlined"
                                value={connection.paidAmount}
                                onChange={handleChange}
                                name="paidAmount"
                            />
                            <Grid container>
                                <Grid item xs={4} sm={6} md={5}>
                                    <FormControl className={classes.formControl} >
                                        <InputLabel id="demo-simple-select-label" >Berner Type</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            onChange={handleChange}
                                            style={{ width: "180px" }}
                                        >
                                            <MenuItem value="GT 2B">GT 2B</MenuItem>
                                            <MenuItem value="GT 3B">GT 3B</MenuItem>
                                            <MenuItem value="GT 4B">GT 4B</MenuItem>
                                            <MenuItem value="SINGLE B">SINGLE B</MenuItem>
                                            <MenuItem value="EXTRA B">EXTRA ARB</MenuItem>
                                        </Select>

                                    </FormControl>

                                </Grid>
                                <Grid item xs={4} sm={12} md={6}>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="Quantity"
                                        label="Quantity"
                                        type="text"
                                        variant="outlined"
                                        onChange={handleChange}
                                        size="small"
                                        name="quantity"
                                    />
                                </Grid>
                            </Grid>

                            <TextField
                                autoFocus
                                margin="dense"
                                id="rate"
                                label="Rate"
                                type="text"
                                variant="outlined"
                                onChange={handleChange}
                                size="small"
                                name="rate"
                            />
                            <TextField
                                autoFocus
                                margin="dense"
                                id="remarks"
                                label="Remarks"
                                type="text"
                                variant="outlined"
                                value={connection.remarks}
                                onChange={handleChange}
                                name="remarks"
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpen(false)} variant="contained" color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={handleUpdateConnection} variant="contained" color="primary">
                            update
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div>
                {loadingTable ?
                    <Container component="main" >
                        {loading ? <div style={{ paddingTop: "30px", justifyContent: "center", alignItems: "center", textAlign: "center", width: "100%" }}><p>Please...</p> <CircularProgress /> </div> :
                            <MaterialTable
                                title="Jaman Hp Sales History"
                                data={data}
                                //@ts-ignore
                                columns={columns}
                                options={{
                                    exportButton: true,
                                    exportAllData: true,
                                    filtering: true,
                                    sorting: true,
                                    pageSizeOptions: [5, 20, 50, 100, 200, 500],
                                    headerStyle: {
                                        backgroundColor: '#01579b',
                                        color: '#FFF'
                                    }
                                }}
                            />
                        }
                    </Container> : null}
            </div>
        </React.Fragment>
    );
}

export default ConnectionDashboard